export function addToCart(products: {
    label: string;
    qty: number;
    designData?: string;
}[]) {
    window.postMessage({
        target: 'projectLists',
        products: products.map(({ label, qty, designData }) => ({
            productCode: label,
            productName: label,
            qty,
            ...(designData ? { designData } : {}),
        })),
    }, '*');
}
